



















import {Vue, Component} from 'vue-property-decorator';
import {toI18n} from '@/utils/commonUtils';

@Component
export default class CustomProperty extends Vue {
  private close() {
    window.close();
  }

  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_POP_PRODUCTLIST_' + needToI18nStr));
  }

  private created() {
    document.body.classList.add('popup', 'popup_small');
    window.name = 'customProperty';
  }
}
